import { generateHomeAddendumDocument } from "../api/docusign";
import { useRef } from "react";
import Loader, { Types } from "./gdk/Loader";
import useUsStateOptions from "../hooks/useUsStateOptions";

export default function AlertsFlyout({ flyoutRef, alerts, onClose, onSetAlertLoading = () => { } }) {
    const errorToastRef = useRef();
    const usStateOptions = useUsStateOptions();

    const handleDocusign = (alertItem) => {
        const data = alertItem?.data || {};
        onSetAlertLoading(alertItem?.id, true);
        const stateName = usStateOptions.find(s => s.value === data.State)?.label || data.State;

        const generateHomeAddendumDocumentRequest = {
            AgentName: `${data.FirstName} ${data.LastName}`.trim(),
            AgencyName: data.AgencyName,
            FirstName: data.FirstName,
            LastName: data.LastName,
            Email: data.EmailAddress,
            City: data.AddressCity,
            State: data.State,
            StateName: stateName,
            Zip: data.AddressZipCode,
            ContractSignedDate: data.ContractSignedDate,
            PostDocusignUrl: "isHomeDocusign=true",
            AlertId: alertItem?.id
        };

        const success = (res) => {
            window.open(res.docServiceUrl, "_self");
            onSetAlertLoading(alertItem?.id, false);
        }

        const failure = () => {
            if (errorToastRef.current) {
                errorToastRef.current.setAttribute("visible", "");

                const toastEl = errorToastRef.current;
                const trySetIcon = () => {
                    const iconEl = toastEl?.shadowRoot?.querySelector('gds-component-header > gds-icon[slot="icon"]');
                    if (iconEl) {
                        iconEl.setAttribute('icon-type', 'non-critical-warning');
                        iconEl.setAttribute('color', 'reverse');
                        return true;
                    }
                    return false;
                };
                if (!trySetIcon()) {
                    queueMicrotask(trySetIcon);
                    setTimeout(trySetIcon, 50);
                }
                setTimeout(() => {
                    if (errorToastRef.current) {
                        errorToastRef.current.removeAttribute("visible");
                    }
                }, 5000);
            }
            // ensure loading resets on failure
            onSetAlertLoading(alertItem?.id, false);
        }

        generateHomeAddendumDocument(generateHomeAddendumDocumentRequest, success, failure);
    }

    return <gds-flyout page-navbar-exists ref={flyoutRef}>
        <div>
            <h2>Alerts</h2>
            <gds-toast ref={errorToastRef} type="informational">
                We couldn't load the DocuSign document.<span slot="toast-subtext">Please try again in a moment.</span>
            </gds-toast>
            {(alerts || []).map(alertItem => {
                const data = alertItem?.data || {};
                return (
                    <gds-alert key={alertItem?.id}>
                        <gds-alert-message type={data.HueAlertType?.toLowerCase() ?? "action"}>
                            {data.AlertHeader}
                            <span slot="content">
                                {data.AlertDesc}
                            </span>
                            {data?.AlertId === "CarrierAddendum" && data?.FormId === "HomeAddendum" &&
                                <div slot="cta">
                                    {data?.isLoading ? <Loader type={Types.Inline} /> :
                                        <gds-icon-button icon-type="e-signature" onClick={() => handleDocusign(alertItem)} >
                                            Click here to sign
                                        </gds-icon-button>
                                    }
                                </div>
                            }
                        </gds-alert-message>
                    </gds-alert>
                );
            })}
            <gds-button onClick={onClose}>Close</gds-button>
        </div>
    </gds-flyout>
}